import React , { useEffect, useState } from "react";
import { headerData } from '../../../data/modules/my-validations-header';
import MainContainer from "../../../components/MainContainer";
import { Grid, Button } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import SearchIcon from '@mui/icons-material/Search';
import CalendarView from "./CalendarView";
import PlanningService from "../../../services/PlanningService";
import Box from '@mui/material/Box';
import Message from "../../tools/Message";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";
import { Alert, AlertTitle } from '@mui/material';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { LoadingButton } from '@mui/lab';
import TableViewIcon from '@mui/icons-material/TableView';
import ExcelJS from 'exceljs';
import LoadingSimpleBackdrop from "../../tools/LoadingSimpleBackdrop";

function PlanningListv(props) {
  const noteStyle = {
    backgroundColor: '#d4edda', 
    color: '#155724',            
    borderRadius: '5px',
    border: '1px solid #c3e6cb',
    maxWidth: '100%',
    textAlign: 'center',
    margin: '0' 
  };
  const [filter, setFilter] = useState({
    date_debut: '',
    date_fin: '',
    idperiode:''
  });
  const [showTable, setShowTable] = useState(false);
  const [details,setDetails]=useState([]);
  const [periode,setPeriode]=useState([]);
  const [active,setActive]=useState(true);
  const [loading,setLoading]=useState(false);
  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = React.useState(false);

  const [message, setMessage] = React.useState({
    open: false,
    color: 'green',
    messageInfo: '',
  });
  const { open, color, messageInfo } = message;

  const getFrenchMonthName = (mois) => {
      const moisArray = [
          "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
          "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
      ];
      return moisArray[mois - 1];
  };

  function handleCloseMessage(){
    setMessage({...message, open: false});
  }

  function handleChange(event) {
    const { name, value } = event.target;
    setFilter({ ...filter, [name]: value }); 
  }

  function handleChangePeriode(event, value) {
      const datedebut=moment(value.date_debut).format('YYYY-MM-DD');
      const datefin=moment(value.date_fin).format('YYYY-MM-DD');
      setFilter({ ...filter, date_debut: datedebut,date_fin:datefin,idperiode:value.periode_id}); 
  }

  const handleExportExcel = async () => {
        const dateDebut=filter.date_debut;
        const dateFin=filter.date_fin;
        const generateDateRange = (startDate, endDate) => {
            const dates = [];
            let current = new Date(startDate);
            while (current <= endDate) {
                dates.push(new Date(current));
                current.setDate(current.getDate() + 1);
            }
            return dates;
        };

        const groupDaysByMonth = (dates) => {
            const months = {};
            dates.forEach(date => {
                const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
                if (!months[key]) months[key] = [];
                months[key].push(date.getDate());
            });
            return months;
        };

        const getCellColor = (statut) => {
            const colors = {
                'en attente': 'FF87CEEB',
                'planifie': 'FF78B785',
                'valide': 'FF78B785',
                'nouveau': 'FF87CEEB',
                'refuse': 'FFFF0000'
            };
            return colors[statut] || 'FFFFFFFF';
        };

        // 1. Génération des dates et regroupement par mois
        const dates = generateDateRange(new Date(dateDebut), new Date(dateFin));
        const monthsGrouped = groupDaysByMonth(dates);
        const monthKeys = Object.keys(monthsGrouped).sort((a, b) => {
            const [yA, mA] = a.split('-').map(Number);
            const [yB, mB] = b.split('-').map(Number);
            return yA === yB ? mA - mB : yA - yB;
        });

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Planning des Missions');

        const headerRow1 = ['Demandeur'];
        const headerRow2 = [''];

        monthKeys.forEach(monthKey => {
            const [year, month] = monthKey.split('-').map(Number);
            const days = monthsGrouped[monthKey];
            headerRow1.push(...Array(days.length).fill(`${getFrenchMonthName(month)} ${year}`));
            headerRow2.push(...days.map(day => String(day)));
        });

        worksheet.addRow(headerRow1);
        worksheet.addRow(headerRow2);

        // Fusion des cellules du premier header par mois
        let colStart = 2;
        monthKeys.forEach(monthKey => {
            const colEnd = colStart + monthsGrouped[monthKey].length - 1;
            worksheet.mergeCells(1, colStart, 1, colEnd);
            colStart = colEnd + 1;
        });

        // Styles pour en-têtes
        const header1 = worksheet.getRow(1);
        const header2 = worksheet.getRow(2);
        [header1, header2].forEach(row => {
            row.eachCell(cell => {
                cell.font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 12 };
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FF425B8A' }
                };
                cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                cell.border = {
                    top: { style: 'thin' },
                    bottom: { style: 'thin' },
                    left: { style: 'thin' },
                    right: { style: 'thin' }
                };
            });
        });

        // 4. Remplir les données
        details.forEach(user => {
            const rowData = [user.name];
            const rowColors = ['FFFFFFFF'];

            monthKeys.forEach(monthKey => {
                const currentMonth = parseInt(monthKey.split('-')[1]);
                const currentYear = parseInt(monthKey.split('-')[0]);

                monthsGrouped[monthKey].forEach(day => {
                    const detail = user.details?.find(d => {
                        const jour = parseInt(d.jour, 10);
                        const mois = parseInt(d.mois, 10);
                        return jour === day && mois === currentMonth;
                    });

                    if (detail) {
                        rowData.push(detail.code || '');
                        rowColors.push(getCellColor(detail.statut));
                    } else {
                        rowData.push('');
                        rowColors.push('FFFFFFFF');
                    }
                });
            });

            const row = worksheet.addRow(rowData);

            row.eachCell({ includeEmpty: true }, (cell, colIndex) => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: rowColors[colIndex - 1] }
                };
                cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                cell.border = {
                    top: { style: 'thin' },
                    bottom: { style: 'thin' },
                    left: { style: 'thin' },
                    right: { style: 'thin' }
                };
            });
        });

        worksheet.columns.forEach((col, i) => {
            col.width = i === 0 ? 25 : 6;
        });

        worksheet.views = [
            { state: 'frozen', xSplit: 1, ySplit: 2 } 
        ];

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const fileName = `planning_missions_${new Date().toISOString().split('T')[0]}.xlsx`;

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);

};

  function handleFilter(event) {
     setOpenLoadingSimpleBackdrop(true);
    if (filter.date_debut===''&& filter.idperiode==='') {
        setMessage({...message, open: true, color: 'red', messageInfo: 'Veuillez choisir une période de validation.'});
    } else {
        PlanningService.getplanning(filter.idperiode).then((result) => {
            if (result && result.data) {
                setShowTable(true); 
                setActive(false);
                setDetails(result.data);
                setOpenLoadingSimpleBackdrop(false);
            }
            else{
                setMessage({...message, open: true, color: 'red', messageInfo: 'Aucun planning n\'est disponible entre ces dates'});
                setActive(true);
                setOpenLoadingSimpleBackdrop(false);
            }
        });
    }
    
  }

  function handlevalidate(event) {
    setLoading(true);
    setOpenLoadingSimpleBackdrop(true);
    if (filter.date_debut===''&& filter.idperiode==='') {
        setMessage({...message, open: true, color: 'red', messageInfo: 'Veuillez choisir une période de validation.'});
        setLoading(false);
    } else {
      PlanningService.tousvalidatemission(details,periode[0].periode_id).then((result) => {
        if (result && result.data) {
          setDetails(result.data);
          setLoading(false);
          setMessage({...message, open: true, color: 'green', messageInfo: 'Succès'});
          setActive(true);
          setOpenLoadingSimpleBackdrop(false);
        }
        else{
          setOpenLoadingSimpleBackdrop(false);
          setMessage({...message, open: true, color: 'red', messageInfo: 'Veuillez réessayer.'});
        }
      });
    }  
  }

  useEffect(() => {
    PlanningService.periodelist().then((result) => {
        if (result && result.data) {
          const periodeactive = result.data.filter(item => item.active === "true");
          setPeriode(periodeactive);
        }
        else{
           setPeriode([]);
        }
    });
 }, []);

  return (
    <MainContainer {...headerData}>
      <React.Fragment>
        <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
         <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
          <Grid container spacing={4}>
                   <Grid item xs={12}>
                          <Alert severity="info">
                            <AlertTitle>Info</AlertTitle>
                               Veuillez choisir la période de validation pour la planification de la mission.
                            </Alert>
                    </Grid>
                    <Grid item xs={3}>
                     <Button
                        variant="contained"
                        color="primary"
                        onClick={handleFilter} 
                        style={{ fontWeight: 600, width: "100%", display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                     >
                        <SearchIcon style={{ marginRight: '8px' }} />
                        Consulter les plannings
                     </Button>
                 </Grid>  
                 <Grid item xs={4}>
                    <Autocomplete
                        onChange={handleChangePeriode}
                        options={periode} 
                        getOptionLabel={(option) => option.description + ' (' + moment(option.date_debut).format('DD/MM/YYYY') + ' à '+ moment(option.date_fin).format('DD/MM/YYYY')+ ')'}
                        renderInput={(params) => (
                            <TextField
                            {...params}
                            fullWidth
                            label="Période de validation"
                            size="small"
                            variant="outlined"
                            InputProps={{ ...params.InputProps, type: "search" }}
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={2}>
                    
                </Grid>
                <Grid item xs={3}>
                   <LoadingButton
                        loading={loading}  
                        variant="contained"
                        onClick={handlevalidate} 
                        style={{ 
                            fontWeight: 600, 
                            width: "100%", 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center',
                            backgroundColor:"#8FBC8F" 
                        }}
                        disabled={loading}  
                    >
                        <DoneAllIcon style={{ marginRight: '8px' }} />
                        Valider tout les plannings
                    </LoadingButton>
                </Grid>
                <Grid item xs={3}>
                    <Box
                        component="span"
                        sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)', width: '15px', height: '15px', background: '#87CEEB' }}
                    >
                    </Box>
                    Planning en attente de validation 
                </Grid>
                <Grid item xs={3}>
                    <Box
                        component="span"
                        sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)', width: '15px', height: '15px', background: '#78b785' }}
                    >
                    </Box>
                    Planning validé 
                </Grid>
                <Grid item xs={3}>
                    <Box
                        component="span"
                        sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)', width: '15px', height: '15px', background: 'red' }}
                    >
                    </Box>
                    Planning refusé
                </Grid>
               <Grid item xs={3}>
                {showTable && filter.date_debut && filter.date_fin && (
                    <Button
                      variant="contained"
                      onClick={handleExportExcel}
                      sx={{
                        fontWeight: 600,
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#9E9E9E',
                        color: '#fff',
                        '&:hover': {
                          backgroundColor: '#7E7E7E',
                        }
                      }}
                      >
                    <TableViewIcon sx={{ marginRight: '8px' }} />
                    Export Excel
                  </Button>
                )}
              </Grid>
                <Grid item xs={12}>
                   {showTable && filter.date_debut && filter.date_fin && (
                      < CalendarView  
                      startDate={new Date(filter.date_debut)}
                      endDate={new Date(filter.date_fin)}
                      datatables={details}
                      periode={filter.idperiode}
                      />
                    )}
                </Grid>
            </Grid>
           
      </React.Fragment>
    </MainContainer>
  );
}

export default PlanningListv;
